import { render, staticRenderFns } from "./form-point-time.vue?vue&type=template&id=465a5d20"
import script from "./form-point-time.vue?vue&type=script&lang=js"
export * from "./form-point-time.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports